import { Fragment, useEffect } from 'react'

import { Highlight, Prism, themes } from 'prism-react-renderer'
import { useHydrated } from 'remix-utils/use-hydrated'

import { loadJSON, loadJava, loadMarkupTemplating, loadRuby } from './syntax-highlighting' // weirdness abounds when importing this directly from the prismjs components lib, so we'll just do it this way
import { useDarkMode } from '~/shared/components/DarkMode/hook'

export function Fence({ children, language }) {
  const { isDark } = useDarkMode()
  const isHydrated = useHydrated()

  useEffect(() => {
    loadMarkupTemplating(Prism)
    loadJava(Prism)
    loadRuby(Prism)
    loadJSON(Prism)
  }, [])

  return (
    isHydrated && <Highlight
      code={children?.trimEnd() || ''}
      language={language}
      theme={isDark() ? themes.oneDark : themes.oneLight}
    >
      {({ className, style, tokens, getTokenProps }) => (
        <pre className={className} style={style} data-testid="codeblock">
          <code>
            {tokens.map((line, lineIndex) => (
              // eslint-disable-next-line react/no-array-index-key
              <Fragment key={lineIndex}>
                {line
                  .filter(token => !token.empty)
                  .map((token, i) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <span key={i} {...getTokenProps({ token })} />
                  ))}
                {'\n'}
              </Fragment>
            ))}
          </code>
        </pre>
      )}
    </Highlight>
  )
}